import React, { useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import AuthContext from '../context/AuthContext';
import UserForm from '../components/users/UserForm';
import UserList from '../components/users/UserList';
import { useUsers } from '../hooks/useUsers';

const UserManagement = ({ users: propsUsers, addUser: propsAddUser, loading: propsLoading }) => {
  const { user, loading: authLoading } = useContext(AuthContext);
  
  // Use props if provided (lifted state from AdminPortal), otherwise fall back to local hook
  const localUsers = useUsers(user, authLoading);
  
  const users = propsUsers || localUsers.users;
  const loading = propsLoading !== undefined ? propsLoading : localUsers.loading;
  const addUser = propsAddUser || localUsers.addUser;

  if (user?.type !== 'admin') return <div className="p-5 text-center">Access Denied</div>;

  return (
    <div>
      <h1 className="mb-4">User Management</h1>
      <Row>
        <Col md={4}>
          <UserForm onAdd={addUser} />
        </Col>
        <Col md={8}>
          <h3 className="h5 mb-3 text-muted small text-uppercase font-weight-bold">System Users</h3>
          <UserList users={users} loading={loading} />
        </Col>
      </Row>
    </div>
  );
};

export default UserManagement;
